import {ContentApiDef} from "../..";
import {Options} from "../contract/source";

export const isEqualsArray = (arrA: any[], arrB: any[]): boolean => {
  if (arrA.length !== arrB.length) return false;

  return arrA.every((valueA, indexA) => valueA == arrB[indexA]);
}

export const passthrough = (
  self: ContentApiDef|{options: Options},
): any => { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  const fn = (results): any => results;

  return fn.bind(self);
}

export const getKeyValue = <U extends keyof T, T extends Record<string, unknown>>(
  key: U,
  obj: T
): any => obj[key];
